import { PlanTier } from 'src/constants/PlanTier';

// ─────────────────────────────────────────────
// PLAN → INTEGER RANK MAP
// Lower-cased keys for runtime lookup (currentPlanTier from API is lowercased before lookup)
// ─────────────────────────────────────────────
export const PLAN_MAP = {
  [PlanTier.FREE.toLowerCase()]: 0,
  [PlanTier.STANDARD.toLowerCase()]: 1,
  [PlanTier.PREMIUM.toLowerCase()]: 2,
  [PlanTier.ENTERPRISE.toLowerCase()]: 3,
};

// ─────────────────────────────────────────────
// CURRENCY HELPERS
// ─────────────────────────────────────────────
export const getCurrencySymbol = (currency) => (currency === 'INR' ? '₹' : '$');

export const getActivePrice = (plan, currency) =>
  currency === 'INR' ? plan.priceMonthlyINR : plan.priceMonthlyUSD;

export const getActivePerUser = (plan, currency) =>
  currency === 'INR' ? plan.perUserINR : plan.perUserUSD;

export const getBasePrice = (plan, currency) =>
  currency === 'INR' ? plan.basePriceINR : plan.basePriceUSD;

export const getPerUser = (plan, currency) =>
  currency === 'INR' ? plan.perUserINR : plan.perUserUSD;

// ─────────────────────────────────────────────
// CALCULATION HELPERS
// ─────────────────────────────────────────────
export const calculateTotalPrice = ({ basePrice, perUser, enableUsers, userCount }) => {
  const effectiveUserCount = enableUsers ? userCount : 0;
  return Number(basePrice || 0) +
       Number(effectiveUserCount || 0) * Number(perUser || 0);
};

export const getEffectiveUserCount = (enableUsers, userCount) => (enableUsers ? userCount : 0);

// ─────────────────────────────────────────────
// PLAN HELPERS
// ─────────────────────────────────────────────

/**
 * Ordered list of plan tiers from lowest to highest.
 * Derived from PlanTier enum to stay in sync automatically.
 */
export const PLAN_TIER_ORDER = [
  PlanTier.FREE.toLowerCase(),
  PlanTier.STANDARD.toLowerCase(),
  PlanTier.PREMIUM.toLowerCase(),
  PlanTier.ENTERPRISE.toLowerCase(),
];

/**
 * Returns the next plan tier above the given tier (lowercase).
 * Returns null if already at the highest tier (enterprise).
 * @param {string} planTier - e.g. 'premium'
 * @returns {string|null} - e.g. 'enterprise'
 */
export const getNextPlanTier = (planTier) => {
  const idx = PLAN_TIER_ORDER.indexOf((planTier || PlanTier.FREE).toLowerCase());
  if (idx === -1 || idx >= PLAN_TIER_ORDER.length - 1) return null;
  return PLAN_TIER_ORDER[idx + 1];
};

export const isCustomPlan = (plan) =>
  plan.priceMonthlyINR === 'Custom' ||
  plan.priceMonthlyUSD === 'Custom' ||
  plan.priceMonthly === 'Custom';

export const isSamePlanCheck = (currentPlanName, selectedPlanName) =>
  currentPlanName?.toUpperCase() === selectedPlanName?.toUpperCase();

export const getAllFeatures = (plan) => [
  ...(plan.includedFeatures || []).map((f) => ({ text: f, included: true })),
  ...(plan.excludedFeatures || []).map((f) => ({ text: f, included: false })),
];
